import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Pedido } from 'src/app/model/pedido';

@Component({
  selector: 'app-controle-caixa',
  templateUrl: './controle-caixa.page.html',
  styleUrls: ['./controle-caixa.page.scss'],
})
export class ControleCaixaPage implements OnInit {






  // tslint:disable-next-line: no-inferrable-types
  showSearch: boolean = false;
  pedidos: Pedido[] = [];
  pedido: Pedido;

  user: string;
  pass: string;

  data1: string;
  data2: string;

  dataAtual;
  dataMesPassado;

  tipoPedido = "todos";
  tipoRelatorio;

  dataAtualFormatada;
  dataMesPassadoFormatada;

  data3MesPassado;
  data3MesPassadoFormatada;

  data6MesPassado;
  data6MesPassadoFormatada;

  dataSemanaCorrente;
  dataMesCorrente;

  status = [];
  formasPagameto = [];

  data: any;
  mostrarData = false;
  tipoPesquisa = "mes";

  dataaux2;
  dataaux1;

  tipoPedido2 = "";
  formaPagamento = "";
  dataPesquisada = new Date().toISOString().split('T')[0];

  quantidade = 0;

  teste;

  titulo;


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private pedidoapi: PedidoService,
    private global: GlobalService,
    private router: Router,) { }


  ngOnInit() {
    const hoje = new Date();
    // Pega o número do dia da semana (0 = Domingo, 1 = Segunda, ..., 6 = Sábado)
    const dayOfWeek = hoje.getDay();
    // Subtrai o número do dia da semana de hoje para obter a data de domingo da semana corrente
    const sundayOfWeek = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - dayOfWeek);
    this.dataSemanaCorrente = sundayOfWeek.toISOString().split('T')[0];

    // Cria uma nova data com o dia 1 do mês corrente
    let primeiroDiaDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.dataMesCorrente = primeiroDiaDoMes.toISOString().split('T')[0];

    this.dataAtual = new Date();
    this.dataAtualFormatada = this.dataAtual.toISOString().split('T')[0];

    this.loadStatus();

    const idParam = this.route.snapshot.paramMap.get('tipo');
    if (idParam) {
      this.tipoRelatorio = idParam;
    }

    this.data1 = this.dataAtualFormatada;
    this.data2 = this.dataAtualFormatada;

  }

  ionViewWillEnter() {
    this.titulo = "Controle de Caixa";
    this.loadPedidos();
    this.loadStatus();
  }


  periodoPesquisa(periodo: any) {
    this.tipoPesquisa = periodo;
  }

  ativaDatas() {
    this.mostrarData = true;
  }

  desativaDatas() {
    this.mostrarData = false;
  }


  async loadPedidos() {
    const dataAtual = this.dataAtualFormatada.replace(/\-/gi, '');
    const semanaCorrente = this.dataSemanaCorrente.replace(/\-/gi, '');
    const mesCorrente = this.dataMesCorrente.replace(/\-/gi, '');

    switch (this.tipoPesquisa) {

      case "hoje":
        this.dataaux1 = dataAtual + '235959';
        this.dataaux2 = dataAtual + '000000';
        break;

      case "semanal":
        this.dataaux1 = dataAtual + '235959';
        this.dataaux2 = semanaCorrente + '000000';
        break;

      case "mes":
        this.dataaux1 = dataAtual + '235959';
        this.dataaux2 = mesCorrente + '000000';
        break;


      case "personalizado":
        const data1aux = this.data1.replace(/\-/gi, '');
        const data2aux = this.data2.replace(/\-/gi, '');

        this.dataaux1 = data2aux + '235959';
        this.dataaux2 = data1aux + '000000';


        break;
    }


  }


  gerarPdf() {
    const data1 = this.dataaux1;
    const data2 = this.dataaux2;
    const tipo = this.tipoPedido2;
    const tipo2 = this.tipoPesquisa;
    const tipo3 = this.formaPagamento;



    this.router.navigate(['/gerar-controle-caixa/' + data1 + '/' + data2 + '/' + tipo + '/' + tipo2 + '/' + tipo3 + '']);


    //this.router.navigate(['/gerar-relatorio']);
  }






  async loadStatus() {
    this.pedidoapi.pegarFormasPagamento()
      .then(res => {
        console.log(res);
        this.formasPagameto = res.map(c => {
          return ({ label: c.pagamento.replaceAll("_", " "), value: c.pagamento });
        });
        this.formasPagameto.splice(0, 0, { label: "Todas", value: "todos" })
      })
      .catch(erro => {
        console.log(erro);
        this.toast.showError('Erro ao carregar formas de Pagameto!');
      });


    let statusaux1 = [
      { name: 'Todos', code: 'todos' },
      { name: 'Online', code: 'online' },
      { name: 'Local', code: 'local' }
    ];

    this.status = statusaux1.map(c => {
      return ({ label: c.name, value: c.code });
      // tslint:disable-next-line: align
    })

  }

  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    //this.loadPedidos(this.tipoPedido);
    this.loadPedidos();
  }

  async doSearchBarChange($event: any) {
    const value = $event.target.value;
    this.pedidos = await this.pedidoapi.GetByNome(value);
  }


}

